import { loadNativeModule, describeError } from './loadNativeModule';

export function getAudioOutputStatus (output = 'hdmi') {
    const AudioOutput = loadNativeModule('@brightsign/audiooutput');
    if (!AudioOutput) return { available: false, reason: 'audiooutput module unavailable' };

    try {
        const instance = new AudioOutput(output);

        if (typeof instance.mute === 'undefined' && typeof instance.volumeLinear === 'undefined') {
            return { available: false, reason: 'audiooutput properties unavailable on this firmware' };
        }

        return {
            available: true,
            mute: Boolean(instance.mute),
            volumeLinear: typeof instance.volumeLinear === 'number' ? instance.volumeLinear : null,
            // plugstate requires BrightSign OS 9.0.163+; undefined on older firmware.
            plugstate: typeof instance.plugstate === 'boolean' ? instance.plugstate : null
        };
    } catch (error) {
        return { available: false, reason: `audiooutput threw: ${describeError(error)}` };
    }
}
